import { useEffect, useState } from "react";
import { Main, Paper } from "@goodfill/ui-components";
import { mapCustomerApplicationStateToApi } from "../mapCustomerApplicationStateToApi";
import { CustomerApplicationWizard } from "./CustomerApplicationWizard";
import { Route, Routes } from "react-router-dom";
import { CustomerApplicationFormState } from "../formState/formState";
import { DefaultValues } from "react-hook-form";
import { useRecoilState, useRecoilValue } from "recoil";
import { ValidStep1SignUpState, validStep1State } from "./steps/Step1SignUp/step1SignUpState";
import { StepConfirmation } from "./steps/StepConfirmation/StepConfirmation";
import { createCustomerApplication, saveCustomerApplicationWizard } from "@goodfill/backend-api-client";
import { toastErrorHandler } from "../../../../unexpectedErrorHandler";
import { backendFetcher } from "../../../backendApi/backendApi";
import { UserAuthState, userAuthState } from "../../../../state";
import { CustomerApplication } from "@goodfill/domain-customer-application-types";
import { CustomerApplicationStepNumber } from "./customerApplicationSteps";
import "./steps/CustomerApplicationForm_steps.scss";
import { useLogout } from "../../../useLogout";

export const CustomerApplicationForm = ({
  defaultState,
  defaultStep1State,
}: {
  defaultState: DefaultValues<CustomerApplicationFormState>;
  defaultStep1State: DefaultValues<ValidStep1SignUpState>;
}) => {
  const [validStep1, setValidStep1] = useRecoilState(validStep1State);
  const userAuthData = useRecoilValue<UserAuthState | null>(userAuthState);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    setValidStep1(defaultStep1State as ValidStep1SignUpState);
  }, [defaultStep1State, setValidStep1]);

  const [isLoading, setIsLoading] = useState(false);

  const logout = useLogout();

  const onSubmit = async (data: CustomerApplicationFormState) => {
    if (validStep1 === null || userAuthData === null) {
      return;
    }

    setIsLoading(true);
    (
      await createCustomerApplication(
        backendFetcher,
        userAuthData.idToken,
        // Hack: remove "partial" by type cast
        mapCustomerApplicationStateToApi(data, validStep1, userAuthData.user.userId) as CustomerApplication,
      )
    ).match({
      success: () => {
        setIsSubmitted(true);
      },
      businessMatcher: {
        "": () => {},
      },
      unexpected: toastErrorHandler,
      unauthorized: logout,
    });
    setIsLoading(false);
  };

  const onStepSave = async (
    step: CustomerApplicationStepNumber,
    data: DefaultValues<CustomerApplicationFormState>,
  ) => {
    if (validStep1 === null || userAuthData === null) {
      return;
    }

    setIsLoading(true);
    (
      await saveCustomerApplicationWizard(backendFetcher, userAuthData.idToken, {
        step,
        userId: `${userAuthData.user.userId}`,
        wizardSubmission: mapCustomerApplicationStateToApi(data, validStep1, userAuthData.user.userId),
      })
    ).match({
      success: () => {},
      businessMatcher: { "": () => {} },
      unexpected: toastErrorHandler,
      unauthorized: logout,
    });
    setIsLoading(false);
  };

  return (
    <>
      <Main>
        <div className="flex my-4 md:my-8">
          <Paper>
            {isSubmitted ? (
              <StepConfirmation />
            ) : (
              <Routes>
                <Route
                  path="step/:step"
                  element={
                    <CustomerApplicationWizard
                      onSubmit={onSubmit}
                      onStepSave={onStepSave}
                      defaultState={defaultState}
                      defaultStep1State={defaultStep1State}
                      isLoading={isLoading}
                    />
                  }
                />
              </Routes>
            )}
          </Paper>
        </div>
      </Main>
    </>
  );
};
